// extracted by mini-css-extract-plugin
export var active = "_72-a";
export var activeIndicator = "_72-9";
export var disabled = "_72-b";
export var fullWidth = "_72-2";
export var lg = "_72-7";
export var md = "_72-6";
export var redoButtonTabGroup = "_72-0";
export var sm = "_72-5";
export var tabButton = "_72-4";
export var tabButtonsContainer = "_72-1";
export var themeDestructive = "_72-d";
export var themeNormal = "_72-c";
export var themeSuccess = "_72-e";
export var xl = "_72-8";
export var xs = "_72-3";